import { Directive, HostBinding } from '@angular/core';

@Directive({ selector: '[ui-legend-vertical]' })
export class UiLegendVerticalDirective {
  constructor() {}

  @HostBinding('class') elementClass = 'ui-legend-vertical';
}
